import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

import {
  MobileSelectionToggleBar,
  MobileSelectionTopbar,
  ScrollOuter,
  MobileEditBtn,
} from '../../styles/MobileStyles.js';
import SelectionPersonalise from '../SelectionPersonalise';
import SelectionTotalTracker from '../SelectionTotalTracker';
import SelectionItems from '../SelectionItems';
import Misc from '../common/Misc.svg';
import { AddMsgWrapper } from '../../styles';
import BuyBtn from '../BuyBtn';

const MobileSelectionDisplay = ({
  limit,
  selection,
  sizes,
  handleLimitChange,
  clearSelection,
  updateItemRemove,
  randomise,
  showMessages,
  setShowMessages,
  charLimit,
  rangeName,
  singleMessage,
  setSingleMessage,
  handleAddMessage,
  messages,
  disableMessage,
  handleShowMessages,
  handleSingleMessage,
  clearMultiMessage,
  singleMessageContent,
  currentRange,
  isMobile,
  toggleSingleMessage,
  setSelection,
  editable,
  setEditable,
  personalisationSelected,
  setPersonalisationSelected,
  expanded,
  setExpanded,
  firstMsg,
  setFirstMsg,
  presetMsg,
  setPresetMsg,
  isMini,
  getCharacterCount,
}) => {
  const drawer = useRef();
  const editBtn = useRef();
  const tl = useRef();


  const handleClick = () => {
    setExpanded(!expanded);

    if (expanded && isMobile) {
      setSelection((selection) => {
        let newSelection = [];
        let i = 0;
        selection.forEach((selectionItem) => {
          selectionItem ? newSelection.push(selectionItem) : i++;
        });
        while (i > 0) {
          newSelection.push(null);
          i--;
        }
        return newSelection;
      });
    }
  };

  useEffect(() => {
    if (expanded) {
      document.documentElement.style.overflowY = 'hidden';
      document.documentElement.style.touchAction = 'none';
      document.ontouchmove = (e) => {
        e.preventDefault();
      };
      window.ontouchmove = (e) => {
        e.preventDefault();
      };
    } else {
      document.documentElement.style.overflowY = 'scroll';
      document.documentElement.style.touchAction = 'auto';
    }
  }, [expanded]);

  const handleClearAll = () => {
    clearSelection();
    setEditable(false);
  };

  useEffect(() => {
    tl.current = gsap.timeline({
      paused: true,
    });
    tl.current.to(drawer.current, {
      height: '80vh',
      duration: 0.5,
      ease: 'back.out(1)',
    });
  }, []);

  useEffect(() => {
    expanded ? tl.current.play() : tl.current.reverse();
  }, [expanded]);

  return (
    <MobileSelectionToggleBar
      ref={drawer}
      className={`${expanded ? 'expanded' : ''}`}
    >
      <div>
        <MobileSelectionTopbar $expanded>
          <span
            className="toggle-arrow"
            onClick={handleClick}
          >
            {Misc.MobileSelectionTrayArrow}
          </span>

          <SelectionTotalTracker
            isMobile={isMobile}
            selection={selection}
            limit={limit}
            sizes={sizes}
            setShowMessages={setShowMessages}
            showMessages={showMessages}
            handleLimitChange={handleLimitChange}
          />
          {!editable && !showMessages && expanded && 
            selection.filter((item) => item !== null).length > 0 && (
              <MobileEditBtn ref={editBtn} onClick={() => setEditable(true)}>
                Edit your box
              </MobileEditBtn>
            )}
          {editable && (
            <>
              <MobileEditBtn onClick={handleClearAll}>
                Clear All
              </MobileEditBtn>
            </>
          )}
        </MobileSelectionTopbar>
        <ScrollOuter>
          {expanded && !showMessages ? (
            <>
              <SelectionItems
                limit={limit}
                selection={selection}
                sizes={sizes}
                handleLimitChange={handleLimitChange}
                clearSelection={clearSelection}
                updateItemRemove={updateItemRemove}
                randomise={randomise}
                showMessages={showMessages}
                setShowMessages={setShowMessages}
                charLimit={charLimit}
                rangeName={rangeName}
                singleMessage={singleMessage}
                setSingleMessage={setSingleMessage}
                handleAddMessage={handleAddMessage}
                messages={messages}
                disableMessage={disableMessage}
                handleShowMessages={handleShowMessages}
                handleSingleMessage={handleSingleMessage}
                clearMultiMessage={clearMultiMessage}
                singleMessageContent={singleMessageContent}
                currentRange={currentRange}
                isMobile={isMobile}
                toggleSingleMessage={toggleSingleMessage}
                editable={editable}
                personalisationSelected={personalisationSelected}
                setPersonalisationSelected={setPersonalisationSelected}
                setEditable={setEditable}
                isMini={isMini}
              />
            </>
          ) : expanded && showMessages ? (
            <>
              <SelectionPersonalise
                selection={selection}
                limit={limit}
                currentRange={currentRange}
                handleAddMessage={handleAddMessage}
                firstMsg={firstMsg}
                setFirstMsg={setFirstMsg}
                handleSingleMessage={handleSingleMessage}
                singleMessage={singleMessage}
                setSingleMessage={setSingleMessage}
                clearMultiMessage={clearMultiMessage}
                presetMsg={presetMsg}
                setPresetMsg={setPresetMsg}
                isMobile={isMobile}
                getCharacterCount={getCharacterCount}
              />
              <BuyBtn
                selection={selection}
                limit={limit}
                products={currentRange}
                personalisationSelected={personalisationSelected}
                handleShowMessages={handleShowMessages}
                selectionStage="personalise"
                isMini={isMini}
              />
            </>
          ) : null}
        </ScrollOuter>
      </div>
    </MobileSelectionToggleBar>
  );
};

export default MobileSelectionDisplay;
